import { getExpediaHotelLang, getExpediaHotelMDPCID } from '@fcom/common/utils';
import { ExpediaHotelOrigin } from '@fcom/common/enums';

import type { HotelRoom, HotelSearchForm } from '../interfaces';

export interface HotelDeepLinkOptions {
  lang: string;
  origin: ExpediaHotelOrigin;
}

const pad = (value: number): string => String(value).padStart(2, '0');

const toDate = (date: Date): string => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const roomSplit = (rooms: HotelRoom[]): string => {
  const parts = rooms.map((room, index) => {
    const roomNumber = index + 1;
    const children = room.childAges.filter((age): age is number => age !== null);
    const adults = `&NumAdult${roomNumber}=${room.adults}`;
    if (children.length === 0) {
      return adults;
    }
    const childAges = children.map((age, i) => `&Rm${roomNumber}Child${i + 1}Age=${age}`).join('');
    return `${adults}&NumChild${roomNumber}=${children.length}${childAges}`;
  });

  return `&NumRoom=${rooms.length}${parts.join('')}`;
};

export const hotelSearchDeepLink = (form: HotelSearchForm, options: HotelDeepLinkOptions): string => {
  const { lang, origin } = options;
  const { urlPrefix, additionalQueryParam } = getExpediaHotelLang(lang);

  const cityName = form.destination?.cityName ?? form.destination?.title ?? '';
  const params = [
    `CityName=${encodeURIComponent(cityName)}`,
    form.checkIn ? `InDate=${toDate(form.checkIn)}` : '',
    form.checkOut ? `OutDate=${toDate(form.checkOut)}` : '',
  ]
    .filter(Boolean)
    .join('&');

  const mdpcid = `MDPCID=${getExpediaHotelMDPCID(lang, origin)}`;
  const suffix = additionalQueryParam ? `&${additionalQueryParam}` : '';

  return `https://${urlPrefix}.hotels.finnair.com/go/hotel/search/Destination?${params}${roomSplit(form.rooms)}&${mdpcid}${suffix}`;
};
